export function UnlockIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C23.28 0 30 6.72 30 15C30 23.28 23.28 30 15 30C6.72 30 0 23.28 0 15C0 6.72 6.72 0 15 0Z"
        fill="#75CF00"
      />
      <path
        d="M17.7998 13.8499H12.5398V10.6999C12.5398 9.33992 13.6498 8.22992 15.0098 8.22992C16.3698 8.22992 17.4798 9.33992 17.4798 10.6999H18.7898C18.7898 8.61992 17.0998 6.91992 15.0098 6.91992C12.9198 6.91992 11.2298 8.60992 11.2298 10.6999V14.0999C10.5598 14.4499 10.0898 15.1499 10.0898 15.9599V19.2799C10.0898 20.4499 11.0398 21.3999 12.1998 21.3999H17.7998C18.9698 21.3999 19.9198 20.4499 19.9198 19.2799V15.9599C19.9198 14.7899 18.9698 13.8499 17.7998 13.8499ZM15.5498 17.9299V19.2999C15.5498 19.6099 15.2998 19.8599 14.9898 19.8599C14.6798 19.8599 14.4298 19.6199 14.4298 19.2999V17.9299C13.9698 17.7199 13.6498 17.2599 13.6498 16.7199C13.6498 15.9899 14.2398 15.3899 14.9798 15.3899C15.7198 15.3899 16.3098 15.9899 16.3098 16.7199C16.3098 17.2599 15.9898 17.7199 15.5298 17.9299H15.5498Z"
        fill="#FFFDFE"
      />
    </svg>
  )
}
